<ng-template #template let-row="row">
  <div class="flex--column" *ngIf="row?.priceResults?.length">
    <span *ngIf="row.priceResults[0].currency?.length">
      {{ row.priceResults[0].netPrice | agrCurrency: row.priceResults[0].currency }}
    </span>
    <span *ngIf="!row.priceResults[0].currency">
      {{ row.priceResults[0].netPrice | agrCurrency: ' ' }}
    </span>
    <div class="text--label">
      {{ row.priceResults | formatUnitPrice }}
    </div>
  </div>
  <div class="flex--column" *ngIf="!row?.priceResults?.[0] && cartStatus === cartLifeCycle.simulating">
    <span class="spinner-text blink-soft">{{ 'cart.cart-column-priceSpinnerText' | translate }}</span>
  </div>
</ng-template>
